require('./$.set-species')('RegExp');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es6.regexp.constructor.js
// module id = 428
// module chunks = 0